import { GameVars } from "./../../GameVars";
import { GameConstants } from "../../GameConstants";
import { Button } from "../../utils/Button";
import { RoomScene } from "./RoomScene";
import { AudioManager } from "../../managers/AudioManager";

export class ShowAdversariesLayer extends Phaser.GameObjects.Container {

    private chars: Phaser.GameObjects.Image[];
    private playButtonContainer: Phaser.GameObjects.Container;

    private ids: string[];
    private positions: number[];

    private index: number;
    private f: number;
    private f2: number;
    private startSelection: boolean;

    private midContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene, ids: string[]) {

        super(scene);

        this.ids = ids;

        this.chars = [];

        this.midContainer = new Phaser.GameObjects.Container(this.scene);
        this.midContainer.x = GameConstants.GAME_WIDTH / 2;
        this.midContainer.scaleX = GameVars.scaleX;
        this.add(this.midContainer);

        let charImg = new Phaser.GameObjects.Image(this.scene, -385 / GameVars.scaleX, 200, "texture_atlas_1", "rival_unknown.png");
        charImg.setScale(.9);
        this.midContainer.add(charImg);
        this.chars.push(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, 0, 140, "texture_atlas_1", "rival_unknown.png");
        charImg.setScale(.9);
        this.midContainer.add(charImg);
        this.chars.push(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, 385 / GameVars.scaleX, 200, "texture_atlas_1", "rival_unknown.png");
        charImg.setScale(.9);
        this.midContainer.add(charImg);
        this.chars.push(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, -385 / GameVars.scaleX, GameConstants.GAME_HEIGHT / 2 + 80, "texture_atlas_1", "rival_unknown.png");
        charImg.setScale(.9);
        this.midContainer.add(charImg);
        this.chars.push(charImg);

        charImg = new Phaser.GameObjects.Image(this.scene, 385 / GameVars.scaleX, GameConstants.GAME_HEIGHT / 2 + 80, "texture_atlas_1", "rival_unknown.png");
        charImg.setScale(.9);
        this.midContainer.add(charImg);
        this.chars.push(charImg);

        this.index = 0;
        this.f = 0;
        this.f2 = 0;
        this.startSelection = false;

        this.positions = [1, 2, 3, 0, 4];

        let titleLabel = new Phaser.GameObjects.Image(this.scene, 0, GameConstants.GAME_HEIGHT / 2 + 30, "texture_atlas_1", "meet_rivals.png");
        titleLabel.setScale(.7);
        this.midContainer.add(titleLabel);

        this.scene.tweens.add({
            targets: titleLabel,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Bounce.Out,
            duration: 500,
        });

        this.playButtonContainer = new Phaser.GameObjects.Container(this.scene, 0, GameConstants.GAME_HEIGHT - 50);
        this.playButtonContainer.setScale(.8);
        this.playButtonContainer.visible = false;
        this.midContainer.add(this.playButtonContainer);

        const playButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_yellow.png", "btn_yellow.png", true);
        playButton.onUp(this.onClickPlay, this);
        this.playButtonContainer.add(playButton);

        const playButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, "START", {fontFamily: "Oswald-Medium", fontSize: "30px", color: "#622F20", align: "center"});
        playButtonLabel.setOrigin(.5);
        this.playButtonContainer.add(playButtonLabel); 

        this.scene.time.addEvent({delay: 1500, callback: () => {
            this.startSelection = true;
            AudioManager.playSound("loop_rivals_reveal", true);
        }, callbackScope: this});

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (!this.startSelection) {
            return;
        }

        this.f ++;
        this.f2++;

        if (this.f === 2) {

            this.f = 0;

            for (let i = 0; i < this.chars.length; i++) {

                if (i < this.index) {
                    continue;
                }

                let rand = Math.floor(Math.random() * 7);
                while (("rival_" +  GameConstants.ADVERSARIES[rand] + ".png") === this.chars[i].frame.name) {
                    rand = Math.floor(Math.random() * 7);
                }
    
                this.chars[i].setFrame("rival_" +  GameConstants.ADVERSARIES[rand] + ".png");
            }
            
        }

        if (this.f2 === 60) {
            
            this.chars[this.index].setFrame("rival_" + this.ids[this.positions[this.index]] + ".png");
            this.chars[this.index].scaleX = (this.index === 2 || this.index === 4) ? -.9 : .9;

            this.scene.tweens.add({
                targets: this.chars[this.index],
                scaleX: (this.index === 2 || this.index === 4) ? -1 : 1,
                scaleY: 1,
                ease: Phaser.Math.Easing.Bounce.Out,
                duration: 500,
            });

            let name = new Phaser.GameObjects.Image(this.scene, this.chars[this.index].x, this.chars[this.index].y + 100, "texture_atlas_1", "names_levels_" + this.ids[this.positions[this.index]] + ".png");
            this.midContainer.add(name);

            let confetti = this.scene.add.sprite(this.chars[this.index].x, this.chars[this.index].y, "texture_atlas_1", "confetti_01.png");
            this.midContainer.add(confetti);
            this.midContainer.sendToBack(confetti);

            confetti.anims.play("confetti");

            confetti.on("animationcomplete", () => {
                confetti.visible = false;
            }, this);

            AudioManager.playSound("rival_revealed");
            AudioManager.playSound("check_" + this.ids[this.positions[this.index]]);

            this.f2 = 0;
            this.index++;
        }

        if (this.index === 5) {
            this.startSelection = false;
            AudioManager.stopSound("loop_rivals_reveal");

            this.scene.time.addEvent({delay: 500, callback: () => {
                this.playButtonContainer.visible = true;
                this.scene.tweens.add({
                    targets: this.playButtonContainer,
                    scaleX: 1,
                    scaleY: 1,
                    ease: Phaser.Math.Easing.Bounce.Out,
                    duration: 500,
                });
            }, callbackScope: this});
        }
    }

    private onClickPlay(): void {

        AudioManager.playSound("btn_click");

        RoomScene.currentInstance.startFirstHand();
        this.destroy();
    }
}
